export class SupportRequestCreateModel {
    public name: string;
    public email: string;
    public phone: string;
    public marketingSourceId: string;
    public message: string;

    constructor() {
        this.marketingSourceId = '';
    }
}



// WEBPACK FOOTER //
// ./src/models/supportRequest/support.request.create.model.ts